
export abstract class ElectronicSignatureContract {
  abstract getElectronicSignatureUrl(projectId: number): string;
}
